import React, { useContext } from 'react';
import './Product.css'
import Image from '../shared/Image';
import { useNavigate } from 'react-router-dom';
import { priceFormat } from '../../util/showPriceFormat';
import config from './../../config.json';
import preview from './../../public/image/preview.png'
import MainContext from './../../context/mainContext';
import { setPosition } from '../../util/ScrollRestoration';


const Product = ({ _id, code, name, image, price, inventory, info, comeFrom }) => {

    const navigate = useNavigate();
    const context = useContext(MainContext)
    const thisProduct = { _id, name, image, price, inventory, info, code }
    return (
        <div className='product-card'>
            <div onClick={() => {
                setPosition(`/${comeFrom === 'search' ? 'search' : 'products'}`)
                navigate(`/${comeFrom === 'search' ? 'search' : 'products'}/${_id}`, { state: { ...thisProduct }})
            }}>
                <Image
                    src={image ? `${config.api_address}/upload/${image}` : preview}
                    width={90}
                    height={90}
                    style={{ objectFit: 'cover', opacity: image ? '1' : '.5' }}
                />
                <div className='middle'>
                    <div className='title'>{name}</div>
                    {
                        (context.loggedIn && context.loggedIn.isAdmin) ?
                            <div className='d-flex mt-1'>
                                <span>موجودی</span>
                                <span className='mx-2'>:</span>
                                <span className={`ltr ${Number(inventory) > 0 ? 'text-muted' : 'text-danger'}`}>{inventory}</span>
                            </div> : <div className="mt-2"></div>
                    }
                    {
                        (context.loggedIn && context.loggedIn.status === 'Enable') ?
                        <div>
                            <span>قیمت</span>
                            <span className='me-1'>:</span>
                            <span className='text-success'>{priceFormat(String(price))} ریال</span>
                        </div>
                        :
                        <div style={{maxWidth:'130px', fontSize:'.7rem'}} className='text-muted'>
                            {
                                context.loggedIn ?
                                `برای مشاهده ی قیمت باید عضویت شما تأیید شود`
                                :
                                ` برای مشاهده قیمت ابتدا وارد حساب کابری شوید`
                            }
                           
                        </div>

                    }
                </div>
                <button className='btn btn-sm rounded-pill btn-success d-flex align-items-center'>
                    خرید
                    <i className='fa fa-chevron-left ms-1'></i>
                </button>
            </div>
        </div>
    );
}

export default Product;